module.exports = __webpack_public_path__ + "img/dots_rbb1.c28b5060.png";